module.exports = __webpack_public_path__ + "media/images/store/google_play_hover-06c13b0ba57fb4f81d8a91932d074c47.png";